<div class="editor">
  <div class="editor-bar">
    <button
      class="editor-bar-icon"
      [class.active]="isStyled().bold"
      matTooltip="Bold"
      (click)="onBold()"
    >
      <i class="material-icons">format_bold</i>
    </button>
    <button
      class="editor-bar-icon"
      [class.active]="isStyled().italic"
      matTooltip="Italic"
      (click)="onItalic()"
    >
      <i class="material-icons">format_italic</i>
    </button>
    <button
      class="editor-bar-icon"
      [class.active]="isStyled().underline"
      matTooltip="Underline"
      (click)="onUnderline()"
    >
      <i class="material-icons">format_underline</i>
    </button>
  </div>
  <div
    class="content"
    contenteditable
    spellcheck="false"
    placeholder="Type something"
    (click)="detectChanges()"
    (keyup)="detectChanges()"
    [innerText]="initialContent"
    (input)="updateContent(contentField.innerHTML)"
    #contentField
  ></div>
</div>
